// import { Button, Descriptions, Form, Modal,EditOutlined,form } from "antd";
// import Paragraph from "antd/es/skeleton/Paragraph";

// <div> className = "about-container"
//     <card>
//         <avatar>size={120}</avatar>
//         <title>name = "Zhou"</title>
//         <Paragraph>
//             description = "This is a description"
//         </Paragraph>
//         <Descriptions>
//             <Descriptions.Item label="邮箱">3441661045@qq.com</Descriptions.Item>
//             <Descriptions.Item label="技术栈">暂无</Descriptions.Item>
//             <Descriptions.Item label="兴趣爱好">暂无</Descriptions.Item>
//         </Descriptions>
//         <Button>
//             type = "primary"
//             icon = {<EditOutlined />}
//             style = {{ marginRight: 10 }}
//             onClick = {() =>{
//             }}
//             编辑个人信息
//         </Button>
//         <Modal 
//             title = "编辑个人信息"
//         >   
//             <Form
//                 form = {form}
//                 layout = "vertical"
//             >
//                 <Form.Item
//                     label = "头像(URL)"
//                     name = "avatar"
//                     rules = {[{ required: true, message: '请输入头像URL' },]}
//                 > 
//                 </Form.Item>
//                 <Form.Item
//                     label = "姓名"
//                     name = "name"
//                     rules = {[{ required: true, message: '请输入姓名' },]}
//                 >
//                 </Form.Item>
//                 <Form.Item
//                     label = "个人简介"
//                     name = "introduce"
//                     rules = {[{ required: true, message: '请输入个人简介' },]}
//                 > 
//                 </Form.Item>
//                 <Form.Item
//                     label = "更详细的介绍"
//                     name = "detail"
//                     rules = {[{ required: true, message: '请输入更详细的介绍' },]}
//                 >  
//                 </Form.Item>
//                 <Form.Item
//                     label = "联系邮箱"
//                     name = "email"
//                     rules = {[{ required: true, message: '请输入联系邮箱' },]}
//                 >
//                 </Form.Item>
//                 <Form.Item
//                     label = "技术栈"
//                     name = "skills"
//                 > 
//                 </Form.Item>
//                 <Form.Item
//                     label = "兴趣爱好"
//                     name = "hobbies"
//                 > 
//                 </Form.Item>
//                 <Form.Item>
//                     label = "github链接"
//                     name = "github"
//                 </Form.Item>
//                 <Form.Item>
//                     label = "个人主页链接"
//                     name = "personalWebsite"
//                 </Form.Item>
//             </Form>
//             <Button
//                 type = "primary"
//                 onClick = {() =>{
//                 }}
//             >保存</Button>
//         </Modal> 
//     </card>
// </div>
// src/pages/About/index.js
import React, { useState } from 'react';
import { 
  Card, 
  Avatar, 
  Typography, 
  Button, 
  Form, 
  Input, 
  Modal, 
  Space,
  Tag
} from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  EditOutlined, 
  GithubOutlined,
  LinkOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const About = ({ userInfo, isLoggedIn, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();

  const handleEdit = () => {
    form.setFieldsValue(userInfo);
    setIsEditing(true);
  };

  const handleSave = (values) => {
    onUpdate(values);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  return (
    <div className="user-info-card" style={{ maxWidth: 800, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <Avatar 
          size={120} 
          icon={<UserOutlined />}
          src="https://tu.tuhemmei.com/zb_users/upload/2023/06/20230613168661723"
          className="user-avatar"
        />
        <Title level={2} style={{ marginTop: 16 }}>
          Hi，我是 {userInfo.name}！
        </Title>
        <Paragraph type="secondary">{userInfo.bio}</Paragraph>
      </div>

      {!isEditing ? (
        <>
          <div style={{ marginBottom: 24 }}>
            <Title level={4}>个人介绍</Title>
            <Paragraph>{userInfo.detail}</Paragraph>
          </div>

          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div className="info-item">
              <span className="info-label"><MailOutlined /> 邮箱：</span>
              <span>{userInfo.email}</span>
            </div>

            <div className="info-item">
              <span className="info-label">技术栈：</span>
              {userInfo.techStack === '暂无' ? (
                <span>{userInfo.techStack}</span>
              ) : (
                <span>{userInfo.techStack}</span>
              )}
            </div>

            <div className="info-item">
              <span className="info-label">兴趣爱好：</span>
              {userInfo.hobbies === '暂无' ? (
                <span>{userInfo.hobbies}</span>
              ) : (
                <span>{userInfo.hobbies}</span>
              )}
            </div>

            <div className="info-item">
              <span className="info-label"><GithubOutlined /> GitHub：</span>
              {userInfo.github !== '#' ? (
                <a href={userInfo.github} target="_blank" rel="noopener noreferrer">
                  {userInfo.github}
                </a>
              ) : (
                <span>暂无</span>
              )}
            </div>

            <div className="info-item">
              <span className="info-label"><LinkOutlined /> 个人主页：</span>
              {userInfo.homepage !== '#' ? (
                <a href={userInfo.homepage} target="_blank" rel="noopener noreferrer">
                  {userInfo.homepage}
                </a>
              ) : (
                <span>暂无</span>
              )}
            </div>
          </Space>

          {isLoggedIn && (
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <Button 
                type="primary" 
                icon={<EditOutlined />}
                onClick={handleEdit}
              >
                编辑个人信息
              </Button>
            </div>
          )}
        </>
      ) : (
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          style={{ maxWidth: 600, margin: '0 auto' }}
        >
          <Form.Item
            name="name"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="bio"
            label="个人简介"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="detail"
            label="详细描述"
          >
            <TextArea rows={4} />
          </Form.Item>

          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="techStack"
            label="技术栈"
          >
            <Input placeholder="用逗号分隔，如：React, Node.js, Python" />
          </Form.Item>

          <Form.Item
            name="hobbies"
            label="兴趣爱好"
          >
            <Input placeholder="用逗号分隔，如：阅读, 摄影, 旅行" />
          </Form.Item>

          <Form.Item
            name="github"
            label="GitHub链接"
          >
            <Input placeholder="https://github.com/yourusername" />
          </Form.Item>

          <Form.Item
            name="homepage"
            label="个人主页链接"
          >
            <Input placeholder="https://your-website.com" />
          </Form.Item>

          <Form.Item style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" style={{ marginRight: 16 }}>
              保存
            </Button>
            <Button onClick={handleCancel}>
              取消
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default About;